import React from 'react';

import Registration from './registration';
export default function Pages(props) {
    return {
        Registration,
    };
}
